module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.235df0ce.woff2";